/**
 * WEFT Product Page - JavaScript
 * - バリアント切替（Color × Size）
 * - 在庫切れ判定
 * - 価格更新
 * - Ajaxカート追加
 * - サムネイル切替、FAQ、ルックブック、Sticky bar
 */
(function() {
  'use strict';

  // 二重実行ガードフラグ(関数宣言と同時にトップで定義)
  var __weftInitialized = false;

  function init() {
    if (__weftInitialized) return;
    __weftInitialized = true;
    initThumbs();
    initBuyPanel();
    initFAQ();
    initLookbook();
    initStickyBar();
    initReveal();
  }

  // 初期化(1 回のみ実行を保証)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  /* ===== Thumbnails ===== */
  function initThumbs() {
    const thumbContainers = document.querySelectorAll('[data-weft-thumbs]');
    thumbContainers.forEach(container => {
      const thumbs = container.querySelectorAll('button');
      const root = container.closest('.weft');
      const mainFrame = root && root.querySelector('[data-weft-main]');
      if (!mainFrame) return;
      thumbs.forEach(t => {
        if (t.dataset.weftThumbBound) return;
        t.dataset.weftThumbBound = '1';
        t.addEventListener('click', () => {
          thumbs.forEach(x => x.classList.remove('active'));
          t.classList.add('active');
          const img = t.querySelector('img');
          if (img && mainFrame.querySelector('img')) {
            mainFrame.querySelector('img').src = img.src;
            mainFrame.querySelector('img').srcset = img.srcset || '';
          }
          mainFrame.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    });
  }

  /* ===== Buy panel: variants, qty, add to cart ===== */
  function initBuyPanel() {
    const form = document.querySelector('[data-weft-form]');
    if (!form) return;

    const variantsEl = form.querySelector('[data-weft-variants]');
    let variants = [];
    try {
      variants = JSON.parse(variantsEl.textContent);
    } catch (e) {
      console.error('[WEFT] variants parse error:', e);
      return;
    }

    const root = form.closest('.weft');
    const variantInput = form.querySelector('[data-weft-variant-id]');
    const qtyInput = form.querySelector('[data-weft-qty-input]');
    const priceEl = root.querySelector('[data-weft-price]');
    const colorNameEl = root.querySelector('[data-weft-color-name]');
    const sizeNameEl = root.querySelector('[data-weft-size-name]');
    const sbColor = root.querySelector('[data-weft-sb-color]');
    const sbSize = root.querySelector('[data-weft-sb-size]');
    const sbPrice = root.querySelector('[data-weft-sb-price]');
    const addBtn = form.querySelector('[data-weft-add]');
    const sbAddBtn = root.querySelector('[data-weft-sb-add]');

    let selectedColor = null;
    let selectedSize = null;
    let qty = 1;

    /* どのoption indexがcolor/sizeかを推測（option1/option2/option3のどこに入っているか） */
    const swatches = form.querySelectorAll('[data-weft-swatches] .swatch');
    const sizeBtns = form.querySelectorAll('[data-weft-sizes] .size-btn');

    // 初期: 最初のswatchをactive
    if (swatches.length) {
      const initActive = form.querySelector('[data-weft-swatches] .swatch.active') || swatches[0];
      initActive.classList.add('active');
      selectedColor = initActive.dataset.color;
    }

    function findVariant() {
      if (!selectedColor || !selectedSize) return null;
      // option1/2/3のどこかにcolor/sizeが入っている前提で照合
      return variants.find(v => {
        const vals = [v.option1, v.option2, v.option3].filter(x => x !== null && x !== undefined);
        return vals.includes(selectedColor) && vals.includes(selectedSize);
      });
    }

    function findVariantsByColor(color) {
      return variants.filter(v => {
        const vals = [v.option1, v.option2, v.option3];
        return vals.includes(color);
      });
    }

    function updateSizeAvailability() {
      if (!selectedColor) return;
      const colorVariants = findVariantsByColor(selectedColor);
      sizeBtns.forEach(btn => {
        const size = btn.dataset.size;
        const variant = colorVariants.find(v => {
          const vals = [v.option1, v.option2, v.option3];
          return vals.includes(size);
        });
        if (!variant || !variant.available) {
          btn.classList.add('oos');
        } else {
          btn.classList.remove('oos');
        }
      });
    }

    function updateSelectedVariant() {
      const v = findVariant();
      if (v) {
        variantInput.value = v.id;
        if (priceEl && typeof v.price === 'number') {
          priceEl.textContent = formatMoney(v.price);
          if (sbPrice) sbPrice.textContent = formatMoney(v.price);
        }
        if (addBtn) {
          if (v.available) {
            addBtn.disabled = false;
            addBtn.textContent = 'カートに追加 — ADD TO CART';
          } else {
            addBtn.disabled = true;
            addBtn.textContent = 'SOLD OUT — 在庫切れ';
          }
        }
      }
    }

    function formatMoney(cents) {
      // Shopify は JPY でも内部的に price × 100 で保持しているため /100 が必要
      const yen = Math.round(cents / 100);
      return '¥' + yen.toLocaleString('ja-JP');
    }

    /* Color swatches */
    swatches.forEach(s => {
      s.addEventListener('click', () => {
        swatches.forEach(x => x.classList.remove('active'));
        s.classList.add('active');
        selectedColor = s.dataset.color;
        if (colorNameEl) colorNameEl.textContent = selectedColor;
        if (sbColor) sbColor.textContent = selectedColor;
        updateSizeAvailability();
        updateSelectedVariant();
      });
    });

    /* Size buttons */
    sizeBtns.forEach(b => {
      b.addEventListener('click', () => {
        if (b.classList.contains('oos')) return;
        sizeBtns.forEach(x => x.classList.remove('active'));
        b.classList.add('active');
        selectedSize = b.dataset.size;
        if (sizeNameEl) {
          sizeNameEl.textContent = selectedSize;
          sizeNameEl.style.color = '';
        }
        if (sbSize) sbSize.textContent = 'サイズ ' + selectedSize;
        updateSelectedVariant();
      });
    });

    /* Qty */
    const qtyEl = form.querySelector('[data-weft-qty]');
    const qtyMinus = form.querySelector('[data-weft-qty-minus]');
    const qtyPlus = form.querySelector('[data-weft-qty-plus]');
    if (qtyMinus) qtyMinus.addEventListener('click', () => {
      qty = Math.max(1, qty - 1);
      if (qtyEl) qtyEl.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
    });
    if (qtyPlus) qtyPlus.addEventListener('click', () => {
      qty = Math.min(9, qty + 1);
      if (qtyEl) qtyEl.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
    });

    const purchasesDisabled = form.getAttribute('data-purchases-disabled') === 'true';

    /* Form submit (Ajax cart add) */
    form.addEventListener('submit', e => {
      e.preventDefault();
      if (purchasesDisabled) return;
      if (!selectedSize) {
        if (sizeNameEl) {
          sizeNameEl.textContent = '⚠ サイズを選んでください';
          sizeNameEl.style.color = '#b9986b';
        }
        // スクロールで購入パネル先頭へ
        const buy = form.closest('[data-weft-buy]');
        if (buy) buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      addToCart(form);
    });

    /* Sticky bar add */
    if (sbAddBtn) {
      sbAddBtn.addEventListener('click', () => {
        if (purchasesDisabled) return;
        if (!selectedSize) {
          if (sizeNameEl) {
            sizeNameEl.textContent = '⚠ サイズを選んでください';
            sizeNameEl.style.color = '#b9986b';
          }
          const buy = form.closest('[data-weft-buy]');
          if (buy) buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        addToCart(form);
      });
    }

    function addToCart(formEl) {
      if (purchasesDisabled || !addBtn) return;
      const formData = new FormData(formEl);
      const orig = addBtn.textContent;
      addBtn.textContent = '追加中...';
      addBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
      .then(r => r.json())
      .then(data => {
        if (data.status && data.status >= 400) {
          // エラー
          addBtn.textContent = data.description || 'エラー';
          setTimeout(() => {
            addBtn.textContent = orig;
            addBtn.disabled = false;
          }, 2200);
          return;
        }
        addBtn.textContent = '✓ 追加しました';
        // カートカウントを更新（DawnのカートUIに通知）
        document.documentElement.dispatchEvent(new CustomEvent('cart:added', { bubbles: true }));
        // ヘッダーのカートバッジ更新
        updateCartBadge();
        // WEFT カスタムモーダル表示
        showCartAddedModal(data);
        setTimeout(() => {
          addBtn.textContent = orig;
          addBtn.disabled = false;
        }, 1800);
      })
      .catch(err => {
        console.error('[WEFT] cart add error:', err);
        addBtn.textContent = '通信エラー';
        setTimeout(() => {
          addBtn.textContent = orig;
          addBtn.disabled = false;
        }, 2200);
      });
    }

    // 初期表示で在庫を反映
    updateSizeAvailability();
  }

  /* ===== カートバッジ自動更新 ===== */
  function updateCartBadge() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const count = cart.item_count || 0;

        // WEFT カスタムヘッダーのバッジ更新
        document.querySelectorAll('[data-weft-cart-count]').forEach(badge => {
          if (count > 0) {
            badge.textContent = count;
            badge.style.display = '';
          } else {
            badge.style.display = 'none';
          }
        });

        // Dawn デフォルトヘッダーのバッジ更新(存在する場合)
        const cartIcon = document.getElementById('cart-icon-bubble');
        if (cartIcon) {
          let bubble = cartIcon.querySelector('.cart-count-bubble');
          if (count > 0) {
            if (!bubble) {
              bubble = document.createElement('div');
              bubble.className = 'cart-count-bubble';
              bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
              cartIcon.appendChild(bubble);
            }
            const numSpan = bubble.querySelector('span[aria-hidden="true"]');
            if (numSpan) numSpan.textContent = count < 100 ? count : '';
            const hiddenSpan = bubble.querySelector('.visually-hidden');
            if (hiddenSpan) hiddenSpan.textContent = count + ' items in cart';
          } else if (bubble) {
            bubble.remove();
          }
        }
      })
      .catch(err => console.error('[WEFT] cart badge update error:', err));
  }

  /* ===== カート追加モーダル ===== */
  function showCartAddedModal(item) {
    // 既存モーダル削除
    const existing = document.getElementById('weft-cart-modal');
    if (existing) existing.remove();

    // 価格フォーマット（cents → ¥XX,XXX）
    function formatYen(cents) {
      const yen = Math.round(cents / 100);
      return '¥' + yen.toLocaleString('ja-JP');
    }

    const productTitle = item.product_title || item.title || 'WEFT メリノウールTシャツ';
    const variantTitle = item.variant_title || '';
    const price = item.final_price != null ? item.final_price : item.price;
    const imageUrl = item.image || item.featured_image && item.featured_image.url || '';

    const modal = document.createElement('div');
    modal.id = 'weft-cart-modal';
    modal.className = 'weft-cart-modal';
    modal.innerHTML = `
      <div class="wcm-backdrop" data-wcm-close></div>
      <div class="wcm-dialog" role="dialog" aria-modal="true" aria-labelledby="wcm-title">
        <button type="button" class="wcm-x" data-wcm-close aria-label="閉じる">×</button>
        <div class="wcm-head">
          <p class="wcm-title-ja" id="wcm-title">カートに追加しました</p>
          <p class="wcm-title-en">CART ADDED</p>
        </div>
        <div class="wcm-body">
          ${imageUrl ? `<div class="wcm-img"><img src="${imageUrl}" alt="" loading="eager"></div>` : ''}
          <div class="wcm-info">
            <p class="wcm-brand">WEFT</p>
            <p class="wcm-name">${escapeHtml(productTitle)}</p>
            ${variantTitle ? `<p class="wcm-variant">${escapeHtml(variantTitle)}</p>` : ''}
            <p class="wcm-price">${formatYen(price)} <span class="wcm-tax">(税込)</span></p>
          </div>
        </div>
        <a href="/cart" class="wcm-cta">カートを見る <span class="wcm-arrow">›</span></a>
        <button type="button" class="wcm-close-btn" data-wcm-close>× 閉じる</button>
      </div>
    `;
    document.body.appendChild(modal);

    // 表示アニメーション
    requestAnimationFrame(() => modal.classList.add('open'));

    // 閉じる処理
    modal.querySelectorAll('[data-wcm-close]').forEach(el => {
      el.addEventListener('click', () => closeCartAddedModal());
    });
    document.addEventListener('keydown', wcmKeydown);

    // body スクロール止め
    document.body.style.overflow = 'hidden';
  }

  function closeCartAddedModal() {
    const modal = document.getElementById('weft-cart-modal');
    if (!modal) return;
    modal.classList.remove('open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', wcmKeydown);
    setTimeout(() => modal.remove(), 200);
  }

  function wcmKeydown(e) {
    if (e.key === 'Escape') closeCartAddedModal();
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({
      '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'
    }[c]));
  }

  // モーダル用スタイル注入（1 回だけ）
  function injectCartModalStyles() {
    if (document.getElementById('weft-cart-modal-styles')) return;
    const style = document.createElement('style');
    style.id = 'weft-cart-modal-styles';
    style.textContent = `
      .weft-cart-modal{position:fixed;inset:0;z-index:9999;opacity:0;pointer-events:none;transition:opacity .2s ease}
      .weft-cart-modal.open{opacity:1;pointer-events:auto}
      .weft-cart-modal .wcm-backdrop{position:absolute;inset:0;background:rgba(0,0,0,.4)}
      .weft-cart-modal .wcm-dialog{position:relative;width:min(92vw,440px);margin:8vh auto 0;background:#fff;padding:28px 24px 20px;box-sizing:border-box;font-family:"Shippori Mincho","Noto Serif JP",serif;color:#1a1a1a;box-shadow:0 8px 40px rgba(0,0,0,.15);transform:translateY(8px);transition:transform .2s ease}
      .weft-cart-modal.open .wcm-dialog{transform:translateY(0)}
      .weft-cart-modal .wcm-x{position:absolute;top:10px;right:12px;background:none;border:0;font-size:24px;line-height:1;cursor:pointer;color:#1a1a1a;padding:6px}
      .weft-cart-modal .wcm-head{border-bottom:1px solid #d8cfbe;padding-bottom:14px;margin-bottom:18px}
      .weft-cart-modal .wcm-title-ja{margin:0;font-size:16px;font-weight:500;letter-spacing:.05em}
      .weft-cart-modal .wcm-title-en{margin:6px 0 0;font-size:22px;font-weight:500;letter-spacing:.12em;font-family:"Cormorant Garamond","Jost",serif}
      .weft-cart-modal .wcm-body{display:flex;gap:14px;align-items:flex-start;margin-bottom:18px}
      .weft-cart-modal .wcm-img{flex:0 0 110px;width:110px;height:110px;background:#f6f1e7;overflow:hidden}
      .weft-cart-modal .wcm-img img{width:100%;height:100%;object-fit:cover;display:block}
      .weft-cart-modal .wcm-info{flex:1;min-width:0}
      .weft-cart-modal .wcm-brand{margin:0;font-size:11px;letter-spacing:.18em;color:#7a7a7a;font-family:"Cormorant Garamond","Jost",sans-serif}
      .weft-cart-modal .wcm-name{margin:4px 0 6px;font-size:14px;font-weight:500;line-height:1.5}
      .weft-cart-modal .wcm-variant{margin:0 0 8px;font-size:12px;color:#5a5a5a;letter-spacing:.04em}
      .weft-cart-modal .wcm-price{margin:6px 0 0;font-size:18px;font-weight:500}
      .weft-cart-modal .wcm-tax{font-size:11px;color:#7a7a7a;font-weight:400}
      .weft-cart-modal .wcm-cta{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:14px 16px;background:#1a1a1a;color:#fff;text-decoration:none;font-size:14px;letter-spacing:.08em;text-align:center;transition:background .2s ease;box-sizing:border-box}
      .weft-cart-modal .wcm-cta:hover{background:#2a2a2a}
      .weft-cart-modal .wcm-arrow{font-size:18px;line-height:1}
      .weft-cart-modal .wcm-close-btn{display:block;width:100%;margin-top:10px;padding:10px;background:#fff;border:1px solid #d8cfbe;font-family:inherit;font-size:13px;color:#1a1a1a;cursor:pointer;letter-spacing:.04em}
      @media (max-width:480px){
        .weft-cart-modal .wcm-dialog{margin:4vh auto 0;padding:24px 18px 18px}
        .weft-cart-modal .wcm-img{flex:0 0 90px;width:90px;height:90px}
        .weft-cart-modal .wcm-title-en{font-size:20px}
      }
    `;
    document.head.appendChild(style);
  }
  injectCartModalStyles();

  /* ===== FAQ ===== */
  function initFAQ() {
    document.querySelectorAll('.weft .faq-row').forEach(row => {
      if (row.dataset.weftBound) return;
      row.dataset.weftBound = '1';
      row.addEventListener('click', () => row.classList.toggle('open'));
    });
  }

  /* ===== Lookbook filter & modal ===== */
  function initLookbook() {
    const filter = document.querySelector('[data-weft-lb-filter]');
    const grid = document.querySelector('[data-weft-lb-grid]');
    if (!filter || !grid) return;

    const cards = grid.querySelectorAll('.lb-card');

    filter.addEventListener('click', e => {
      const b = e.target.closest('button');
      if (!b) return;
      filter.querySelectorAll('button').forEach(x => x.classList.remove('active'));
      b.classList.add('active');
      const f = b.dataset.filter;
      cards.forEach(c => {
        let show = false;
        if (f === 'all') show = true;
        else if (f === 'men' || f === 'women') show = c.dataset.gender === f;
        else show = c.dataset.color === f;
        c.classList.toggle('hidden', !show);
      });
    });

    const modal = document.querySelector('[data-weft-lb-modal]');
    if (!modal) return;
    const modalImg = modal.querySelector('[data-weft-lb-img]');
    const modalLbl = modal.querySelector('[data-weft-lb-lbl]');
    const modalTtl = modal.querySelector('[data-weft-lb-ttl]');
    const modalColor = modal.querySelector('[data-weft-lb-color]');
    const modalModel = modal.querySelector('[data-weft-lb-model]');
    const closeBtn = modal.querySelector('[data-weft-lb-close]');

    cards.forEach(c => {
      c.addEventListener('click', () => {
        const img = c.querySelector('.img img');
        const lbl = c.querySelector('.meta span');
        const who = c.querySelector('.who');
        const ttl = c.querySelector('.label');
        if (modalImg) modalImg.innerHTML = img ? '<img src="' + img.src + '" alt="">' : '';
        if (modalLbl) modalLbl.textContent = lbl ? lbl.textContent : '';
        if (modalTtl) modalTtl.textContent = ttl ? ttl.textContent : '';
        if (modalColor) modalColor.textContent = c.dataset.color || '';
        if (modalModel) modalModel.textContent = who ? who.textContent : '';
        modal.classList.add('open');
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', () => modal.classList.remove('open'));
    modal.addEventListener('click', e => { if (e.target === modal) modal.classList.remove('open'); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') modal.classList.remove('open'); });
  }

  /* ===== Sticky cart bar ===== */
  function initStickyBar() {
    const sb = document.querySelector('[data-weft-sticky]');
    if (!sb) return;
    const buyPanel = document.querySelector('[data-weft-buy]');
    if (!buyPanel) return;

    function updateSB() {
      const buyRect = buyPanel.getBoundingClientRect();
      const footer = document.querySelector('footer') || document.querySelector('.shopify-section-footer');
      const footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
      const past = buyRect.bottom < window.innerHeight * 0.4;
      const nearFooter = footerTop < window.innerHeight + 60;
      sb.classList.toggle('show', past && !nearFooter);
    }
    window.addEventListener('scroll', updateSB, { passive: true });
    window.addEventListener('resize', updateSB);
    updateSB();
  }

  /* ===== Reveal animation ===== */
  function initReveal() {
    const targets = document.querySelectorAll('.weft .reveal');
    if (!targets.length) return;
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.05 });
    targets.forEach(el => io.observe(el));
  }

})();
